import {STYLIS_PREPARATION_CONTEXT, StylisContextType} from './stylis'

export const MIRROR_REGEX = /\/\*\s*@mirror\s*\*\//g

export default (
  context: StylisContextType,
  content: string
): string | null | undefined => {
  if (context === STYLIS_PREPARATION_CONTEXT) {
    return content.replace(MIRROR_REGEX, 'transform: scale(-1, 1);')
  }
}

export * from './stylis'
